import { Component, OnInit, ErrorHandler } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';

@Component({
  selector: 'app-clients-form',
  templateUrl: './clients-form.component.html',
  styleUrls: ['./clients-form.component.css']
})
export class ClientsFormComponent implements OnInit {
  data: any;
  districts: any = [];
  d: any = {};
  c: any = {};
  t: any = {};
  taluks: any = [];
  districtId: any;
  client: any;
  C_Id: any;
  mode: any;
  formSubmitted: boolean;

  SelectedProject:any = [];

  expanded: boolean = false;
  p: any = {};

  projectlist: any = [];
  dropdownList: any = [];
  dropdownSettings: any = {};
  //selectedItems:any = [];

  selectedProject: any = [];
  Flag: any;


  project: any = [];
  projects: any = [];
  temp: any = [];
  clientprojectlist: any = [];
  spPro_Id: any;
  checked: boolean = false;

  mobilenopattern = /[0-9\+\-\ ]/;


  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) { }

  ngOnInit() {
    
      this.route.params.subscribe(params => {
        this.mode = params['mode'];
        this.C_Id = params['C_Id'];
      });

      if (this.C_Id != null && this.mode != null)
        this.GetClientDetailsById(this.C_Id);

      if (this.mode != 'view' || this.mode != 'edit') {
        this.GetAllDistricts();
        this.GetAllProjectsForDropdown();
      }
  }

  GetAllDistricts() {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllDistricts();
    this.data.subscribe(
      (response: any) => {
        this.districts = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        //this.errorHandler.HandlerError(error);
      });
    // }
  }

  GetAllTaluks(districtId) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllTaluks(districtId);
    this.data.subscribe(
      (response: any) => {
        this.taluks = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        //this.errorHandler.HandlerError(error);
      });
    // }
  }

  GetAllProjectsForDropdown() {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllProjectsForDropdown();
    this.data.subscribe(
      (response: any) => {
        this.projectlist = response;
        console.log(this.projectlist);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        //this.errorHandler.HandlerError(error);
      });
    // }
  }


  onSubmit(clientform: NgForm) {
    debugger;
    if (!clientform.invalid) {
      document.getElementById('loader-spinner').style.display = "block";
      clientform.value.Client_Projectlist = this.clientprojectlist;
      if(clientform.value.Client_Projectlist.length>0)
      {
      this.data = this.userService.SaveClientDetails(clientform.value);
      this.data.subscribe(
        (response) => {
          document.getElementById('loader-spinner').style.display = "none";
          swal('Success!', 'Saved Successfully.', 'success');
          this.router.navigate(['/home/clients']);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          //this.errorHandler.HandlerError(error);
        });
      }
      else{
        document.getElementById('loader-spinner').style.display = "none";
        swal('Warning!', 'Please select atleast one project.', 'warning');
      }
    }
    else {
      document.getElementById('loader-spinner').style.display = "none";
      swal('Warning!', 'Please Enter all the mandatory fields.', 'warning');
    }
  }

  GetClientDetailsById(C_Id) {
    debugger;
    if (C_Id != undefined) {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.getClientDetailsById(C_Id);
      this.data.subscribe(
        (response) => {
          this.c = response;
          this.GetAllTaluks(this.c.C_District);
          //this.c.C_Taluk = response.C_Taluk;
          this.clientprojectlist = response.Client_Projectlist;
          this.project = response.Client_Projectlist;
        //this.projectlist = response.NotINClient_Projectlist;
          for (var i = 0; i < this.clientprojectlist.length; i++) {
            for (var j = 0; j < this.projectlist.length; j++) {
              if (this.clientprojectlist[i].Tr_Pro_Id == this.projectlist[j].Tr_Pro_Id)
                this.projectlist.splice(j, 1);
            }
          }   
          console.log(this.c.C_Taluk);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
        });
    }
  }

  Update(clientform: NgForm) {
    debugger;
    if (!clientform.invalid) {
      document.getElementById('loader-spinner').style.display = "block";
      // if (this.Flag == 'single')
      //   //clientform.value.Client_Projectlist=this.project;
      //   clientform.value.Client_Projectlist = this.clientprojectlist;
      // if (this.Flag == 'multiple') {
      //   clientform.value.Client_Projectlist = this.projects;
      // }
      clientform.value.Client_Projectlist = this.clientprojectlist;
      this.data = this.userService.updateclientdetails(clientform.value, this.C_Id);
      this.data.subscribe(
        (response) => {
          document.getElementById('loader-spinner').style.display = "none";
          swal('', 'Updated Successfully!', 'success');
          this.router.navigate(['/home/clients']);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          alert(error.error.Message);
        });
    } else {
      document.getElementById('loader-spinner').style.display = "none";
      swal('warning', 'Please fill all the mandatory fields!', 'warning');
      this.formSubmitted = true;
    }

    // 
    // this.dropdownSettings = {
    //   singleSelection: false,
    //   idField: 'id',
    //   textField: 'name',
    //   selectAllText: 'Select All',
    //   unSelectAllText: 'UnSelect All',
    //   itemsShowLimit: 3,
    //   allowSearchFilter: false,
    //   maxHeight:100,
    // };



  }


  RemoveProject(projectId: any) {
    debugger;
    for (var j = 0; j < this.clientprojectlist.length; j++) {
      if (this.clientprojectlist[j].Tr_Pro_Id == projectId) {

        let tem = {
          Tr_Pro_Id: this.clientprojectlist[j].Tr_Pro_Id,
          Tr_Pro_Title: this.clientprojectlist[j].Tr_Pro_Title,
          CP_Inactive:'Y',
          CP_Id :this.clientprojectlist[j].CP_Id,
        }
        this.projectlist.push(tem);
        this.clientprojectlist[j].CP_Inactive='Y';
        console.log(this.projectlist);
       // this.clientprojectlist.splice(j, 1);
      }
    }
  }

 

  // 
  onItemSelect(item: any) {
    debugger;
    this.Flag = 'single';
    this.temp = {
      Tr_Pro_Id: item.Tr_Pro_Id,
      Tr_Pro_Title: item.Tr_Pro_Title,
    }

    this.project.push(this.temp);
    
    for (var j = 0; j < this.projectlist.length; j++) {
      if (this.projectlist[j].Tr_Pro_Id == item.Tr_Pro_Id) {
        this.projectlist.splice(j, 1);
      }
    }
    //for pushing selected into array
    this.clientprojectlist.push(this.temp);
    console.log('in onselect', this.clientprojectlist);
    console.log(item);
    console.log(this.Flag);
  }

  onSelectAll(items: any) {
    this.Flag = 'multiple';
    this.projects = items;
    console.log(items);
  }

  // list = [
  //   { id: 1, name: 'moi' },
  //   { id: 2, name: 'jhjh' }
  // ]


  showCheckboxes() {
    let checkboxes = document.getElementById("checkboxes");
    if (!this.expanded) {
      checkboxes.style.display = "block";
      this.expanded = true;
    } else {
      checkboxes.style.display = "none";
      this.expanded = false;
    }
  }


  AddProjectList(item:any){
    debugger;

   //selectedprojectlist
    for(let i=0; i<this.projectlist.length; i++)
    {
      if(this.projectlist[i].Tr_Pro_Id==item)
      {
        var temp = {
          Tr_Pro_Id: this.projectlist[i].Tr_Pro_Id,
          Tr_Pro_Title: this.projectlist[i].Tr_Pro_Title,
         // IsSelected:true,
      }
      //this.SelectedProject.push(temp);
      this.clientprojectlist.push(temp);

      }
    }

    }


    Cancel(){
      this.c={};
    }







}



// WEBPACK FOOTER //
// ./src/app/masters/clients/clients-form/clients-form.component.ts